import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaLock,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SecureOnlineStoreDevelopmentInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Secure Online Store Development in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Shop with Confidence</Subheading>}
        heading={
          <Heading>
            Secure <span tw="text-primary-500">Online Store Development</span>{" "}
            in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in secure online store development
            in **DIFC**, building robust, protected e-commerce platforms with
            stunning designs to ensure customer trust and business success in
            Dubai’s financial hub.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Secure e-commerce shopping
          "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Digital security concept
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Team working on web development
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Securely Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Secure E-commerce Solutions in DIFC"
        description="We prioritize security without compromising design or performance."
        cards={[
          {
            icon: <FaLock color="#ff5464" size={40} />,
            title: "Top-Tier Security",
            description: "SSL, encryption, and PCI-compliant platforms.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Trusted Transactions",
            description: "Safe payment gateways for customer confidence.",
          },
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Expert Development",
            description: "Built by DIFC’s top e-commerce professionals.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast & Protected",
            description: "Speed optimized with robust security.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Secure",
            description: "Responsive, protected stores for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "Preferred for secure stores in DIFC.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Secure Development Process"
        description={
          <Description>
            We build secure online stores with a meticulous approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Define security and business goals.</li>
              <li>Design: Create intuitive, secure layouts.</li>
              <li>Development: Implement encryption and secure tech.</li>
              <li>Testing: Rigorously check for vulnerabilities.</li>
              <li>Launch: Deploy a fortified, polished store.</li>
              <li>Support: Offer ongoing security updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1566669437687-7040a6926753?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Secure checkout process
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Security monitoring dashboard
          "https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Development team collaboration
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Secure Success in DIFC"
        description="Our secure stores drive trust and results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Safe Sales",
            description: "Boosted conversions with secure design.",
          },
          {
            icon: <FaLock color="#ff5464" size={40} />,
            title: "Zero Breaches",
            description: "Flawless security for a DIFC retailer.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Confidence",
            description: "95% trust rating from DIFC clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Security?</Subheading>}
        heading="Secure Online Stores in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for secure online store development in
            DIFC. Get a fortified, high-performing store that protects your
            customers and brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Team celebrating project success
          "https://images.unsplash.com/photo-1557821552-17105176677c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce payment security
          "https://images.unsplash.com/photo-1535303311164-664fc9ec6532?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
